import {getField, updateField} from "vuex-map-fields"
import { Api } from '@/plugins/axios'
import router from '@/router'


export const state = () => ({
    currentUser: {
        firstname : '',
        lastname : '',
        full_name : '',
        SuperadminLogged: false,
        SuperDeveloperLogged: false,
        house_jet_membership: {},
    },
    modified : 0,   // for caching
    profileImageVersion: 0,
    cu_loading: false
})


export const getters = {
    getField,
    getHouseJetMembership(state){
        return state.currentUser.house_jet_membership
    },
    getCurrentUser(state){
        return state.currentUser
    }
}

export const mutations = {
    updateField,
    resetCurrentUser(state) {
        state.currentUser = {
            firstname : '',
            lastname : '',
            full_name : '',
            SuperadminLogged: false,
            SuperDeveloperLogged: false,
        }
        state.modified = 0
    },
    setCurrentUser(state, user) {
        state.currentUser = user
        state.modified = Date.now()
    },
    bumpProfileImageVersion(state) {
        state.profileImageVersion = Date.now()
    }
}

export const actions = {
    async fetchCurrentUser({ commit }) {
        try {
            const response = await Api.get('/api/v1/admins/me')
            if (response.data && response.data.user) {
                commit('setCurrentUser', response.data.user)
                return response.data.user
            }
            throw new Error('No user data received')
        } catch (error) {
            console.warn('Failed to fetch current user1:', error.message)
            
            commit('resetCurrentUser')
            throw error
        }
    },
    
    async logout({ commit }) {
        try {
            if (!window.IS_MOBILE_APP) {
                await Api.post('/api/v1/auth/logout')
            }
            commit('resetCurrentUser')
        } catch (error) {
            // Still clear user data even if logout call fails
            commit('resetCurrentUser')
        }

        if (window.IS_MOBILE_APP) {
            localStorage.removeItem('jwt_token')
            router.push('/login')
        } else {
            window.location.href = '/login'
        }
    }
}
